
import main from './section/main';
import {gsap} from "gsap";


let bgVideo1 = promokit.video({
    el: '#bg-video1',
    url: 'https://vod.plaync.com/lineage2/update/rf/skill.mp4',
    loop: true,
    autoplay: true,
    preload: true
});

let section1 = {
    id: '#section-1',
    backgroundVideo: bgVideo1
};

let bgVideo2 = promokit.video({
    el: '#bg-video2',
    url: 'https://vod.plaync.com/lineage2/update/rf/weapon.mp4',
    loop: true,
    autoplay: true,
    preload: true
});

let section2 = {
    id: '#section-2',
    backgroundVideo: bgVideo2
};

let bgVideo3 = promokit.video({
    el: '#bg-video3',
    url: 'https://vod.plaync.com/lineage2/update/rf/field.mp4',
    loop: true,
    autoplay: true,
    preload: true
});

let section3 = {
    id: '#section-3',
    backgroundVideo: bgVideo3
};

promokit.page({
    game: 'lineage2',
    cnb: true,
    topButton: true,
    type: 'fixed',
    header:'#section-header',
    footer: {
        fixed: true,
        theme: 'white' //'black', 'white'
    },

    headerButton: {
        el: '.header-button',
        cookie: {
            type: 'year',
            key: 'INDEX_WEB_VISIT_201216_update',
            value: false
        },
        update:true,
        home: true,
        sns: true,
        theme: 'black'
    }
});

promokit.preload({
    complete: () => {
        gsap.fromTo('#section-header', { backgroundSize: '4352px 1674px' },{ duration: 8, backgroundSize: '3840px 1447px' });
       main.enterStart();
    }
});

var layer1 = promokit.layer({
    el: '#layer-1',
    buttons: '.btn-step',
});

var layer2 = promokit.layer({
    el: '#layer-2',
    buttons: '.btn-detail',
});

var layer3 = promokit.layer({
    el: '#layer-3',
    buttons: '.btn-method',
});


var tab = promokit.tab({
    el: '#tab-area',
    fade: true,

});

var slide1 = promokit.slide({
    el: '#slide-1',
    arrow: true,
    infinity: true,
    bullet: true,
});



// WEBPACK FOOTER //
// ./src/js/index.js